import type { ReactElement } from 'react';
import { t } from '@fetmode/i18n';
import { Button } from '@fetmode/ui';
import { useNavigate } from 'react-router-dom';

import { useAuthModal } from '../auth/index.js';
import './CommunityJoinLanding.css';

export function CommunityJoinLanding(): ReactElement {
  const { openAuthModal } = useAuthModal();
  const navigate = useNavigate();

  const openJoin = (): void => {
    openAuthModal({
      mode: 'register',
      intent: 'community',
      onSuccess: () => {
        void navigate('/onboarding/experience', { replace: true });
      },
    });
  };

  const openLogin = (): void => {
    openAuthModal({
      mode: 'login',
      intent: 'community',
      onSuccess: () => {
        void navigate('/community', { replace: true });
      },
    });
  };

  return (
    <section className="community-join">
      <header className="community-join__hero">
        <p className="community-join__eyebrow">{t('common.community.joinEyebrow')}</p>
        <h1 className="community-join__title">{t('common.community.joinTitle')}</h1>
        <p className="community-join__subtitle">{t('common.community.joinSubtitle')}</p>
        <div className="community-join__actions">
          <Button label={t('common.community.joinFree')} onClick={openJoin} />
          <button type="button" className="community-join__login" onClick={openLogin}>
            {t('common.community.joinLogin')}
          </button>
        </div>
        <p className="community-join__fineprint">{t('common.community.joinFineprint')}</p>
      </header>

      <section className="community-join__why" aria-labelledby="community-why-heading">
        <h2 id="community-why-heading">{t('common.community.whyTitle')}</h2>
        <ul className="community-join__reasons">
          <li>
            <strong>{t('common.community.whyFreeTitle')}</strong>
            <span>{t('common.community.whyFreeBody')}</span>
          </li>
          <li>
            <strong>{t('common.community.whyPeopleTitle')}</strong>
            <span>{t('common.community.whyPeopleBody')}</span>
          </li>
          <li>
            <strong>{t('common.community.whyLiveTitle')}</strong>
            <span>{t('common.community.whyLiveBody')}</span>
          </li>
          <li>
            <strong>{t('common.community.whyPrivacyTitle')}</strong>
            <span>{t('common.community.whyPrivacyBody')}</span>
          </li>
        </ul>
      </section>

      <section className="community-join__cta-band">
        <h2>{t('common.community.joinBandTitle')}</h2>
        <p>{t('common.community.joinBandBody')}</p>
        <Button label={t('common.community.joinFree')} onClick={openJoin} />
      </section>
    </section>
  );
}
